if (!customElements.get('sh-book-filters')) {
  customElements.define('sh-book-filters', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('form');
      this.root = this.closest('collection-component');
      this.cards = [...this.root.querySelectorAll('[data-sh-book]')];
      this.fields = [...this.form.querySelectorAll('[data-book-field]')];
      this.query = this.form.elements.book_query;
      this.sort = this.form.elements.book_sort;
      this.fields.filter(field => field.dataset.bookField !== 'subjects').forEach(field => {
        const values = [...new Set(this.cards.map(card => card.dataset[field.dataset.bookField]).filter(Boolean))].sort((a, b) => a.localeCompare(b));
        values.forEach(value => field.add(new Option(value, value)));
      });
      const url = new URL(window.location.href);
      [this.query, ...this.fields].forEach(field => { field.value = url.searchParams.get(field.name) || ''; });
      const sortValue = url.searchParams.get('sort_by') || 'title-ascending';
      if ([...this.sort.options].some(option => option.value === sortValue)) this.sort.value = sortValue;
      this.form.addEventListener('submit', event => event.preventDefault(), options);
      this.form.addEventListener('input', () => this.apply(), options);
      this.form.addEventListener('change', event => {
        if (event.target === this.sort) {
          const next = new URL(window.location.href);
          next.searchParams.set('sort_by', this.sort.value);
          next.searchParams.delete('page');
          window.location.assign(next.href);
        } else this.apply();
      }, options);
      this.form.addEventListener('reset', event => {
        event.preventDefault();
        [this.query, ...this.fields].forEach(field => { field.value = ''; });
        this.apply();
        this.query.focus({ preventScroll: true });
      }, options);
      this.mobile = window.matchMedia('(max-width: 749px)');
      const resizeFilters = () => { this.querySelector('details').open = !this.mobile.matches; };
      this.mobile.addEventListener('change', resizeFilters, options);
      resizeFilters();
      this.form.hidden = false;
      this.apply(false);
    }
    normalize(value) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }
    apply(save = true) {
      const terms = this.normalize(this.query.value.trim()).split(/\s+/).filter(Boolean);
      let count = 0;
      this.cards.forEach(card => {
        const matchesFields = this.fields.every(field => !field.value || (field.dataset.bookField === 'subjects' ? card.dataset.subjects.split(' ').includes(field.value) : card.dataset[field.dataset.bookField] === field.value));
        const haystack = this.normalize(card.dataset.search || '');
        const visible = matchesFields && terms.every(term => haystack.includes(term));
        card.closest('li').hidden = !visible;
        if (visible) count++;
      });
      this.querySelector('.sh-book-count').textContent = this.dataset.countTemplate.replace('[shown]', count).replace('[total]', this.cards.length);
      this.querySelector('.sh-book-empty').hidden = count !== 0;
      if (save) {
        const url = new URL(window.location.href);
        [this.query, ...this.fields].forEach(field => { if (field.value) url.searchParams.set(field.name, field.value); else url.searchParams.delete(field.name); });
        window.history.replaceState(null, '', url);
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
if (!customElements.get('sh-mobile-purchase')) {
  customElements.define('sh-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.root = this.closest('product-info');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.action = this.querySelector('.sh-mobile-purchase__action');
      this.mobile.addEventListener('change', () => this.update(), { signal: this.controller.signal });
      document.addEventListener('focusin', () => this.update(), { signal: this.controller.signal });
      document.addEventListener('focusout', () => requestAnimationFrame(() => this.update()), { signal: this.controller.signal });
      window.addEventListener('scroll', () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.update();
        });
      }, { passive: true, signal: this.controller.signal });
      this.mutations = new MutationObserver(records => { if (records.some(record => !this.contains(record.target))) this.bind(); });
      this.mutations.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'href', 'data-variant-id'] });
      this.bind();
    }
    bind() {
      const source = this.root.querySelector('.silberhaze-purchase a[data-amazon-purchase], product-form .product-form__submit');
      if (!source) { this.hidden = true; return; }
      if (source !== this.source) {
        this.source = source;
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => { this.past = entries[0].boundingClientRect.bottom < 0; this.update(); });
        this.observer.observe(source);
      }
      const signature = [source.href, source.textContent, source.disabled, source.dataset.variantId].join('|');
      if (signature !== this.signature) {
        this.signature = signature;
        this.action.replaceChildren();
        if (source.tagName === 'A') this.action.append(source.cloneNode(true));
        else {
          const hasOptions = this.dataset.hasOptions === 'true';
          const button = document.createElement(hasOptions ? 'a' : 'button');
          if (!hasOptions) button.type = 'button';
          button.className = 'button';
          button.textContent = hasOptions ? this.dataset.optionsLabel : source.textContent.trim();
          if (hasOptions) {
            const picker = this.root.querySelector('variant-selects[id]') || source;
            button.href = `#${picker.id}`;
          } else {
            button.disabled = source.disabled;
            button.addEventListener('click', () => this.source.click());
          }
          this.action.append(button);
        }
      }
      this.update();
    }
    update() {
      this.past = this.source?.getBoundingClientRect().bottom < 0;
      const typing = document.activeElement?.matches('textarea, input[type="text"], input[type="search"], input[type="email"], input[type="tel"], input[type="number"], input[type="password"]');
      const chatting = document.activeElement?.tagName === 'SHOPIFY-CHAT';
      const show = this.mobile.matches && this.past && this.source && !typing && !chatting;
      this.hidden = !show;
      document.body.classList.toggle('sh-mobile-purchase-active', Boolean(show));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.mutations?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      document.body.classList.remove('sh-mobile-purchase-active');
    }
  });
}
